
export const JSESSIONID_KEY = "JSESSIONID";
export const APPID = "wx86ba05efed27d343";

const domain = process.env.VUE_APP_DOMAIN;
const baseUrl = process.env.VUE_APP_BASE_URL;

export function getBaseUrl() {
    // const domain = getDomain(env);
    return `https://${baseUrl}`;
}

export function getDomain() {
    return domain;
}

// https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx86ba05efed27d343&redirect_uri=http%3a%2f%2fticketc-customer.hzy.plus%2fauthorize&response_type=code&scope=snsapi_userinfo&state=WECHAT_WAP_C